import React from 'react';
import { FlightTicketPropType } from 'PropTypes';
import { Card, Form, Col, Row } from 'react-bootstrap';
import AssignmentTypeBadge from 'Components/AssignmentTypeBadge';

// Component to display ticket identifiers
const TicketIdentifiersCard = (props) => {
  const { flyToWorkTicketInfo } = props;
  const isEc = flyToWorkTicketInfo.assignmentType === 'ec';

  return (
    <Card className="staff-profile-card mb-2">
      <Card.Header>
        <i className="fa fa-id-card me-2"></i>Identifiers{' '}
        <AssignmentTypeBadge assignmentType={flyToWorkTicketInfo.assignmentType} />
      </Card.Header>
      <Card.Body>
        <Form>
          <Row>
            <Form.Group as={Col}>
              <Form.Label>Ticket ID</Form.Label>
              <Form.Control type="text" defaultValue={flyToWorkTicketInfo.id} disabled />
            </Form.Group>
            <Form.Group as={Col}>
              <Form.Label>Staff ID</Form.Label>
              <Form.Control type="text" defaultValue={flyToWorkTicketInfo.originalStaffId} disabled />
            </Form.Group>
            {isEc ? (
              <>
                <Form.Group as={Col}>
                  <Form.Label>EC Position ID</Form.Label>
                  <Form.Control type="text" defaultValue={flyToWorkTicketInfo.ecPositionId} disabled />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Slice ID</Form.Label>
                  <Form.Control type="text" defaultValue={flyToWorkTicketInfo.sliceId} disabled />
                </Form.Group>
              </>
            ) : (
              <>
                <Form.Group as={Col}>
                  <Form.Label>MPLID</Form.Label>
                  <Form.Control type="text" defaultValue={flyToWorkTicketInfo.mplid} disabled />
                </Form.Group>
                <Form.Group as={Col}>
                  <Form.Label>Position Assign ID</Form.Label>
                  <Form.Control type="text" defaultValue={flyToWorkTicketInfo.positionAssignId} disabled />
                </Form.Group>
              </>
            )}
          </Row>
          {isEc && (
            <Row className="mt-2">
              <Form.Group as={Col}>
                <Form.Label>Working Country</Form.Label>
                <Form.Control type="text" defaultValue={flyToWorkTicketInfo.workingCountry || ''} disabled />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Department</Form.Label>
                <Form.Control type="text" defaultValue={flyToWorkTicketInfo.departmentLabel || ''} disabled />
              </Form.Group>
              <Form.Group as={Col}>
                <Form.Label>Working Location</Form.Label>
                <Form.Control type="text" defaultValue={flyToWorkTicketInfo.workingLocationLabel || ''} disabled />
              </Form.Group>
            </Row>
          )}
        </Form>
      </Card.Body>
    </Card>
  );
};

TicketIdentifiersCard.propTypes = {
  flyToWorkTicketInfo: FlightTicketPropType.isRequired,
};

export default TicketIdentifiersCard;
